/** ImportSummary — Ergebnis der Zuweisung (angelegt / Dubletten / ohne Agent / Fehler) */
import { AlertCircle, CheckCircle2, X } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function ImportSummary({ result, onClose }) {
  if (!result) return null;
  const ok = result.imported > 0;
  return (
    <div role="status" className={cn('flex items-start gap-3 rounded-xl border p-4', ok ? 'border-dna-paid-fg/20 bg-dna-paid-bg' : 'border-dna-open-fg/20 bg-dna-open-bg')}>
      {ok ? <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-dna-paid-fg" /> : <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-dna-open-fg" />}
      <div className="min-w-0 flex-1 space-y-1 text-[14px] text-dna-text">
        <p className="font-semibold text-dna-primary">
          {result.imported} Lead{result.imported === 1 ? '' : 's'} angelegt und als Aufgabe „Besuchen“ zugewiesen
        </p>
        {result.conflicts.length > 0 && (
          <p className="text-[13px]">{result.conflicts.length} übersprungen (Dublette): {result.conflicts.slice(0, 4).map((c) => `${c.name} – ${c.text}`).join('; ')}</p>
        )}
        {result.noAgent > 0 && <p className="text-[13px]">{result.noAgent} ohne Agent – nicht angelegt.</p>}
        {result.failed.length > 0 && (
          <p className="text-[13px] text-dna-due-fg">Fehler bei {result.failed.map((f) => `${f.name} (${f.text})`).join('; ')}</p>
        )}
      </div>
      <button type="button" aria-label="Schließen" onClick={onClose}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-dna-muted hover:bg-white/60 hover:text-dna-primary">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
